// extracted by mini-css-extract-plugin
export var deliveryRow = "_qw-a";
export var fixedHeight = "_qw-4";
export var freightLogo = "_qw-9";
export var fullWidth = "_qw-3";
export var priceColumn = "_qw-5";
export var radioSelected = "_qw-7";
export var radioUnselected = "_qw-6";
export var selectedOption = "_qw-2";
export var selectedOptionContainer = "_qw-1";
export var selection = "_qw-0";
export var tallSkeletonText = "_qw-8";